<a
  style="cursor: pointer;"
  [routerLink]="[index]"
  routerLinkActive="active"
  class="list-group-item clearfix">
  <div class="pull-left">
    <h4 class="list-group-item-heading">{{holiday.name}}</h4>
    <p class="list-group-item-text">{{holiday.from}} {{holiday.to}}</p>
  </div>
</a>
